import { Navigate, useParams } from 'react-router-dom';
import { Ruthie } from '../../components/Ruthie';
import { FeatureFlag, useFeatureFlagResolved } from '../../services/featureFlag.service';

export default function RuthieConversationPage() {
  const { id } = useParams<{ id: string }>();
  const { value: ruthieEnabled, isLoading } = useFeatureFlagResolved(FeatureFlag.RUTHIE, false);
  if (isLoading) return null;
  if (!ruthieEnabled) return <Navigate to="/" replace />;

  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border-border">
        <h1 className="text-2xl font-bold text-foreground">Data Architect</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Design your semantic layer through natural conversation with Ruthie.
        </p>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        {id && <Ruthie showHistory={true} conversationId={id} />}
      </div>
    </div>
  );
}
